import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Layout } from 'src/components/SimpleKeyboard';

interface KeyboardState {
  isKeyboardVisible: boolean;
  keyboardRef: string;
  layout?: Layout;
}

const initialState: KeyboardState = {
  isKeyboardVisible: false,
  keyboardRef: '',
  layout: Layout.Qwerty
};

const slice = createSlice({
  name: 'keyboard',
  initialState,
  reducers: {
    toggleKeyboard(state: KeyboardState, action: PayloadAction<boolean>) {
      state.isKeyboardVisible = action.payload;
    },
    handleChange(state: KeyboardState, action: PayloadAction<string>) {
      state.keyboardRef = action.payload;
    },
    handleSetKeyboardLayout(state: KeyboardState, action: PayloadAction<Layout>) {
      state.layout = action.payload;
    },
  }
});

export const {
  toggleKeyboard,
  handleChange,
  handleSetKeyboardLayout,
} = slice.actions;

export const reducer = slice.reducer;
export default slice; 